module.exports = __webpack_public_path__ + "img/233-transnistria.58fa75df.svg";